import {DataApi} from '../data-api';
import {EventFilter, EventSettings} from '../../../plugins/event/filter';
import {DataApiDistinctValues, DataApiResult, Event} from '../../../types/data-api';
import {DataApiEndpoint} from '../data-api-endpoint';

/**
 * Endpoint for getting events.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class EventEndpoint extends DataApiEndpoint {
  protected _api: DataApi;

  constructor(api: DataApi) {
    super(api);
    this._api = api;
  }

  /**
   * Finds events by a filter.
   *
   * @param {EventSettings|null} settings Plugin settings
   * @param {EventFilter|null} [filter] Filter
   * @returns {Promise<DataApiResult<EventEndpoint>>}
   */
  public async find(
    settings: EventSettings | null = null,
    filter: EventFilter | null = null
  ): Promise<DataApiResult<Event>> {
    return fetch(this.buildUrl(settings, filter, [
      'dataApi[preset]=event'
    ]))
      .then(response => {
        if (response.status !== 200) {
          throw new Error(`Fetching endpoint failed: ${response.status} ${response.statusText}`);
        }
        return response.json();
      })
      .then((response: DataApiResult<Event>) => {
        return response;
      });
  }

  /**
   * Gets distinct values for events.
   *
   * @param {EventSettings|null} [settings] Plugin settings
   * @returns {Promise<DataApiDistinctValues>}
   */
  public async distinctValues(settings: EventSettings | null = null): Promise<DataApiDistinctValues> {
    return fetch(this.buildUrl(settings, null, [
      'dataApi[preset]=event',
      'dataApi[rows]=9999',
      'dataApi[distinctValues]=1'
    ]))
      .then(response => {
        if (response.status !== 200) {
          throw new Error(`Fetching endpoint failed: ${response.status} ${response.statusText}`);
        }
        return response.json();
      })
      .then((response: DataApiDistinctValues) => {
        return response;
      });
  }
}
